<script setup lang="ts">
import { useHubFileTableContext } from '@/modules/Workspaces/KnowledgeHub/Hubs/hubFileTableContext'
import CheckBox from '@/uiKit/CheckBox.vue'
import IconButton from '@/uiKit/IconButton.vue'
import Menu from '@/uiKit/Menu'
import { computed } from 'vue'

const context = useHubFileTableContext()

const hasAppliedFilter = computed(() => {
  return context.filterErrors.value
})

function onToggleErrorFilter() {
  context.filterErrors.value = !context.filterErrors.value
}
</script>

<template>
  <Menu.Root
    v-slot="{ getTriggerProps }"
    :positioning="{ placement: 'bottom-end', offset: { mainAxis: 4 } }"
  >
    <IconButton
      icon="filter"
      size="lg"
      aria-label="Hub file filter"
      rounded
      :variant="hasAppliedFilter ? 'brand' : 'outline'"
      wide
      v-bind="getTriggerProps()"
    />

    <Menu.Content class="max-w-80 min-w-48">
      <Menu.GroupTitle label="Status" />
      <Menu.Item @select="onToggleErrorFilter">
        <template #prefix>
          <CheckBox
            :checked="context.filterErrors.value"
            class="mx-1"
          />
        </template>
        <template #default> Files with errors </template>
      </Menu.Item>
    </Menu.Content>
  </Menu.Root>
</template>
